const { version } = require('../../../package.json');

export const apiEnvironment = {
	production: false,
	flavor: 'devDebug',
	baseUrl: 'https://dev-api.smoothr.de',
	PAYPAL: {
		BN_CODE: 'SterlixGmbH_MP_Connected',
		JS_URL: 'https://www.paypal.com/sdk/js?client-id=Ac5vAqN4prOBX3YUFPX_L9Bmz3ncsdmOgkz7LuE2zP3yDbIaJB0y3SD4CTBdJqoHQhcWP6-WMklA-thJ&integration-date=2020-09-04&components=buttons,funding-eligibility&currency=',
	},
	hasRecommendations: false,
	bffEndpoint: 'https://bff-service.coolify.smoothr.de/graphql',
	version,
};

// import 'zone.js/dist/zone-error';
